import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="customerRecords";

export function selectByBusinessId(dealId,type,key,parameter){
  return axios({
    url: `/ws/${moduleName}/selectByBusinessId/${dealId}/${type}/${key}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function deleteRecords(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function selectRelationByBusinessId(businessId,parameter){
  return axios({
    url: `/ws/${moduleName}/selectRelationByBusinessId/${businessId}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function selectRelationByBusinessIdAndDataNotNull(businessId,parameter){
  return axios({
    url: `/ws/${moduleName}/selectRelationByBusinessIdAndDataNotNull/${businessId}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export default {
  selectByBusinessId,
  selectRelationByBusinessId,
  deleteRecords,
  selectRelationByBusinessIdAndDataNotNull
}